import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { QuickSignupService } from 'src/app/services/quick-signup-service';
import { SavedPlatesService } from 'src/app/services/saved-plates.service';
import { SessionService } from 'src/app/services/session-service';

/**
 * /saved (dev2): the signed-out shortlist. Lists the plates a visitor saved in
 * this browser, with no sign-in box, plus a free-account panel. Signing in
 * merges these into the account's Saved plates (SavedPlatesService) and moves
 * the visitor to /account/saved. Signed-in visitors go straight there.
 */
@Component({
  selector: 'pla-saved-guest',
  templateUrl: './saved-guest.component.html',
  styleUrls: ['../account-v2/account-v2.component.scss', './saved-guest.component.scss'],
})
export class SavedGuestComponent implements OnInit, OnDestroy {
  public regs: string[] = [];
  public confirmReg: string | null = null;
  private sub?: Subscription;

  constructor(
    private savedPlates: SavedPlatesService,
    private session: SessionService,
    private signup: QuickSignupService,
    private router: Router
  ) {}

  ngOnInit(): void {
    if (this.session.isLoggedIn()) {
      this.router.navigate(['/account/saved'], { replaceUrl: true });
      return;
    }
    this.sub = this.savedPlates.changes.subscribe((set) => (this.regs = [...set].reverse()));
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  public formatReg(registration: string): string {
    const reg = registration.toUpperCase();
    if (/^[A-Z]{2}\d{2}[A-Z]{3}$/.test(reg)) return `${reg.slice(0, 4)} ${reg.slice(4)}`;
    if (/^[A-Z]\d{1,3}[A-Z]{3}$/.test(reg)) return `${reg.slice(0, reg.length - 3)} ${reg.slice(-3)}`;
    if (/^[A-Z]{3}\d{1,3}[A-Z]$/.test(reg)) return `${reg.slice(0, 3)} ${reg.slice(3)}`;
    const dateless = reg.match(/^([A-Z]+)(\d+)$/) || reg.match(/^(\d+)([A-Z]+)$/);
    return dateless ? `${dateless[1]} ${dateless[2]}` : reg;
  }

  public remove(reg: string): void {
    this.confirmReg = null;
    this.savedPlates.unsave(reg).subscribe();
  }

  // Free account: saves merge in on sign-in (SavedPlatesService.refresh).
  public join(startOn: 'login' | 'register'): void {
    this.signup.quickSignup(
      'save your plates',
      undefined,
      (ok: boolean) => {
        if (ok) this.router.navigate(['/account/saved']);
      },
      () => {},
      undefined,
      startOn
    );
  }
}
